import { Theme } from '@mui/material'
// To facilitate fast development I am currently keeping the map style to default (empty array).
// This would be great to expand upon and make in nice einwert colors in the future :)
// https://mapstyle.withgoogle.com/
export const getMapStyle = (_theme: Theme) => []
